//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'select-good-modal',
    props: {
        onSelected: Function,
        shopType: Number,
        goodType: Number,
    },
    data() {
        var vm = this;
        return {
            loading: false,
            saving: false,
            pageSize: 10,
            currentPage: 1,
            list: [],
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '店铺名称',
                    align: 'center',
                    key: 'shopName'
                },
                {
                    title: '商品名称',
                    align: 'center',
                    key: 'goodName'
                },
                {
                    title: '总库存',
                    align: 'center',
                    key: 'totalInventory'
                },
                {
                    title: '操作',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        var edit = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.onRowClick(params.row);
                                }
                            }
                        }, '选择');
                        actions.push(edit);
                        return h('div', actions);
                    }
                }
            ],
            totalCount: 0,
            searchInput: {},
            shops: []
        };
    },
    methods: {
        pageChange(page) {
            // this.$store.commit('hotGood/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('hotGood/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.searchInput.status = 0;
            this.searchInput.shopType = this.shopType;
            this.searchInput.goodType = this.goodType;
            this.loading = true;
            abp.ajax.post('/api/services/app/Good/SearchGoods', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        },
        getShopList() {
            var url = '/api/services/app/Shop/GetShopList';
            if (this.shopType != null) {
                url = url + '?shopType=' + this.shopType;
            }
            abp.ajax.get(url).then(res => {
                this.shops = [];
                this.shops.push(...res.data.result);
                // this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                // this.loading = false;
            });
        }
    },
    created() {
        this.getPage();
        this.getShopList();
    },
    watch: {
        shopType() {
            this.getPage();
            this.getShopList();
        }
    }
};
